const Preconditions = require('./Preconditions.js');

export function createEndpointFromUSPhoneNumber(number, default_value)
{
    if ( !Preconditions.isString(number) )
        return default_value;

    if ( number.startsWith("E164:+1") )
    {
        number = number.substring("E164:+1".length);
    }

    let only_digits = '';

    for ( let i = 0; i < number.length; i++ )
    {
        let cur_char = number.charAt(i);

        if ( cur_char === '0' || cur_char === '1' || cur_char === '2' || cur_char === '3' || cur_char === '4' || cur_char === '5' || cur_char === '6' || cur_char === '7' || cur_char === '8' || cur_char === '9' )
        {
            only_digits += cur_char;
        }
    }


    if ( only_digits.length == 10 )
        return 'E164:+1'+only_digits;

    if ( only_digits.length == 11 && only_digits.charAt(0) === '1' )
        return 'E164:+'+only_digits;

    return default_value;
} 

export function isUSPhoneNumber(number)
{
    return !Preconditions.isNull(createEndpointFromUSPhoneNumber(number, null));
}

export function prettyPrintUsPhoneNumber(endpoint)
{
    if ( !Preconditions.isString(endpoint) ) 
        return endpoint;

    // prettyprint endpoint (for US phone numbers)...
    if ( endpoint.length == 17 && endpoint.startsWith("E164:+1") )
    {
        let label = endpoint.substring("E164:+1".length);
        label = "("+label.substring(0,3)+") "+label.substring(3,6)+"-"+label.substring(6,10);
        return label;
    }

    if ( endpoint.length == 12 && endpoint.startsWith("+1") )
    {
        let label = endpoint.substring("+1".length);
        label = "("+label.substring(0,3)+") "+label.substring(3,6)+"-"+label.substring(6,10);
        return label;
    }

    return endpoint;
}

export function prettyPrintUsPhoneNumberNoParens(endpoint)
{
    if ( !Preconditions.isString(endpoint) ) 
        return endpoint;

    // prettyprint endpoint (for US phone numbers)...
    if ( endpoint.length == 17 && endpoint.startsWith("E164:+1") )
    {
        let label = endpoint.substring("E164:+1".length);
        label = label.substring(0,3)+"-"+label.substring(3,6)+"-"+label.substring(6,10);
        return label;
    }

    if ( endpoint.length == 12 && endpoint.startsWith("+1") )
    {
        let label = endpoint.substring("+1".length);
        label = ""+label.substring(0,3)+"-"+label.substring(3,6)+"-"+label.substring(6,10);
        return label;
    }

    return endpoint;
}

export function slimEndpoint(endpoint)
{
    Preconditions.checkString(endpoint);
    
    while ( endpoint.startsWith("E164:+") )
    {
        endpoint = endpoint.substring("E164:+".length);
    }

    return endpoint;
}

export function fullEndpoint(endpoint)
{
    Preconditions.checkString(endpoint);

    if ( endpoint.startsWith("E164:+") )
        return endpoint;

    return createEndpointFromUSPhoneNumber(endpoint,endpoint);
}

export function getDevEndpointLabel(endpoint, value_if_not_dev_endpoint)
{
    if ( endpoint == 'E164:+14805819026' ) return 'Sal Dev';
    if ( endpoint == 'E164:+13152591020' || endpoint == 'E164:+18445863624' ) return 'Jim Dev';

    return value_if_not_dev_endpoint;
}

export default { 
    createEndpointFromUSPhoneNumber,
    isUSPhoneNumber,
    prettyPrintUsPhoneNumber,
    slimEndpoint,
    fullEndpoint,
    getDevEndpointLabel,
    prettyPrintUsPhoneNumberNoParens
  };